var render = function render(){var _vm=this,_c=_vm._self._c;return _c('manual-notifications',{key:_vm.isVisible,attrs:{"is-loading":_vm.isLoading,"notification-templates":_vm.notificationTemplates,"has-notification-template-access":_vm.hasNotificationTemplateAccess,"language":_vm.account.language},on:{"send-notification":_vm.onSendNotification,"cancel":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }